export default [
  {
    category: "Časovničarkse usluge",
    id: 1,
    services: [
      {
        title: "Pregled časovnika",
        id: 1
      },
      {
        title: "Servis budilnika",
        id: 2
      },
      {
        title: "Servis luksuznog budilnika",
        id: 3
      },
      {
        title: "Servis zidnog časovnika",
        id: 4
      },
      {
        title: "Servis klasičnog ručnog časovnika",
        id: 5
      },
      {
        title: "Servis automatskog časovnika",
        id: 6
      },
      {
        title: "Zamena ključa krunice",
        id: 7
      },
      {
        title: "Zamena pleksiglasa",
        id: 8
      },
      {
        title: "Zamena stakla",
        id: 9
      },
      {
        title: "Servis automata",
        id: 10
      },
      {
        title: "Poliranje pleksiglasa",
        id: 11
      },
      {
        title: "Poliranje stakla",
        id: 12
      },
      {
        title: "Zamena baterije",
        id: 13
      },
      {
        title: "Servis kvarcnih časovnika",
        id: 14
      },
      {
        title: "Servis luksuznih časovnika",
        id: 15
      },
      {
        title: "Zamena kaiševa",
        id: 16
      },
      {
        title: "Zamena narukvice",
        id: 17
      },
      {
        title: "Servis luksuznih časovnika",
        id: 18
      },
    ]
  },
  {
    category: "Usluge popravke nakita",
    id: 2,
    services: [
      {
        title: "Poliranje nakita",
        id: 19
      },
      {
        title: "Obrade, lepljenje nakita",
        id: 20
      },
      {
        title: "Letovanje lančića",
        id: 21
      },
      {
        title: "Fasovanje kamenčića",
        id: 22
      },
      {
        title: "Popravke minđuša",
        id: 23
      },
      {
        title: "Izrada kopči za lančiće",
        id: 24
      },
      {
        title: "Promena štifni na narukvicama",
        id: 25
      }
    ]
  }
]